import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { Box, Grid, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, CircularProgress, FormControlLabel, Checkbox, Tabs, Tab } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import { Alert } from '@material-ui/lab';

const formatNumber = (val) => {
    const num = parseFloat(val) || 0;
    return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime()) || d.getFullYear() < 1900) return 'Aucun paiement enregistre';
    return d.toLocaleString('fr-FR');
};

class NewSimulPrepaid extends Component {
    state = {
        tab: 0,

        amount: '',
        nbMensualites: 1,
        raccordementPaye: false,
        result: null,
        error: null,
        loading: false,

        meterBoxAssoID: '',
        meterBoxID: '',
        meterAmount: '',
        meterContext: null,
        meterResult: null,
        meterError: null,
        meterLoading: false,
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^[0-9.\b]+$/;
        if (value === '' || regex.test(value)) {
            this.setState({ [name]: value });
        }
    }

    handleMeterChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleMeterAmountChange = (e) => {
        const { name, value } = e.target;
        const regex = /^[0-9.\b]+$/;
        if (value === '' || regex.test(value)) {
            this.setState({ [name]: value });
        }
    }

    simulate = async () => {
        const { amount, nbMensualites, raccordementPaye } = this.state;
        const { FixCost, ConnexionCost, DayDeposit, period } = this.props;

        if (!amount || parseFloat(amount) <= 0) {
            this.setState({ error: 'Veuillez saisir un montant', result: null });
            return;
        }

        const priceStepList = (period || []).map(p => ({
            NbKwh: parseFloat(p.days) || 0,
            Price: parseFloat(p.price) || 0,
        })).filter(p => p.Price > 0);

        const body = {
            Amount: parseFloat(amount),
            Deposit: raccordementPaye ? 0 : (parseFloat(ConnexionCost) || 0),
            InitialKWh: raccordementPaye ? 0 : (parseInt(DayDeposit) || 0),
            Fixcost: parseFloat(FixCost) || 0,
            PriceStepList: priceStepList,
            TotalAlreadyPaid: raccordementPaye ? 1 : 0,
            MonthDue: parseInt(nbMensualites) || 0,
        };

        this.setState({ loading: true, error: null, result: null });

        try {
            const response = await fetch('/subscription/simulate-prepaid', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            });
            const data = await response.json();

            if (data.error) {
                this.setState({ error: data.error, result: data.result || null, loading: false });
            } else {
                this.setState({ result: data.result, error: null, loading: false });
            }
        } catch (err) {
            this.setState({ error: 'Erreur de connexion au serveur', loading: false });
        }
    }

    simulateMeter = async () => {
        const { meterBoxAssoID, meterBoxID, meterAmount } = this.state;

        if (!meterBoxAssoID && !meterBoxID) {
            this.setState({ meterError: 'Veuillez fournir un BoxAssoID ou un BoxID', meterContext: null, meterResult: null });
            return;
        }
        if (!meterAmount || parseFloat(meterAmount) <= 0) {
            this.setState({ meterError: 'Veuillez saisir un montant', meterContext: null, meterResult: null });
            return;
        }

        const body = {
            boxAssoID: meterBoxAssoID.trim(),
            boxID: meterBoxID.trim(),
            amount: parseFloat(meterAmount),
        };

        this.setState({ meterLoading: true, meterError: null, meterContext: null, meterResult: null });

        try {
            const response = await fetch('/subscription/simulate-prepaid-from-meter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            });
            const data = await response.json();

            this.setState({
                meterError: data.error || null,
                meterContext: data.context || null,
                meterResult: data.result || null,
                meterLoading: false,
            });
        } catch (err) {
            this.setState({ meterError: 'Erreur de connexion au serveur', meterLoading: false });
        }
    }

    submit = () => {
        if (this.state.tab === 0) {
            return this.simulate();
        }
        return this.simulateMeter();
    }

    renderManualTab() {
        const { FixCost, ConnexionCost, DayDeposit, period, originalPriceStep } = this.props;
        const { amount, nbMensualites, raccordementPaye, result, error, loading } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                        <strong>Parametres de l'abonnement</strong>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Raccordement</TableCell>
                                    <TableCell>{formatNumber(ConnexionCost)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>kWh offerts</TableCell>
                                    <TableCell>{DayDeposit || 0} kWh</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Partie fixe mensuelle</TableCell>
                                    <TableCell>{formatNumber(FixCost)}</TableCell>
                                </TableRow>
                                {period && period.filter(p => p.price).map((p, idx, arr) => {
                                    let prevSeuil = idx === 0 ? 0 : parseFloat(arr[idx - 1].days) || 0;
                                    let seuil = parseFloat(p.days) || 0;
                                    let label = seuil > 0 ? `${prevSeuil} -> ${seuil} kWh` : `${prevSeuil}+ kWh`;
                                    return (
                                        <TableRow key={idx}>
                                            <TableCell>{label}</TableCell>
                                            <TableCell>
                                                {formatNumber(p.price)} / kWh
                                                {originalPriceStep && <span style={{opacity: 0.6}}> ({formatNumber(originalPriceStep.price)} pour {originalPriceStep.kwh} kWh)</span>}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={raccordementPaye}
                                onChange={(e) => this.setState({ raccordementPaye: e.target.checked })}
                                color="primary"
                            />
                        }
                        label="Raccordement deja paye"
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputText
                        type="number"
                        label="Montant paye"
                        value={amount}
                        onChange={this.handleChange}
                        name="amount"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputText
                        type="number"
                        label="Nombre de mensualites"
                        value={nbMensualites}
                        onChange={this.handleChange}
                        name="nbMensualites"
                    />
                </Grid>

                {loading &&
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <CircularProgress size={24} />
                    </Grid>
                }

                {error &&
                    <Grid item xs={12}>
                        <Alert severity="error">{error}</Alert>
                    </Grid>
                }

                {result && result.MonthsUnpaid > 0 &&
                    <Grid item xs={12}>
                        <Alert severity="warning">
                            <strong>Ce paiement serait refuse en production</strong> -- le montant ne couvre pas {result.MonthsUnpaid} mensualite(s) de partie fixe (manque {formatNumber(result.AmountMissing)}).
                        </Alert>
                    </Grid>
                }

                {result && this.renderResultTable(result, FixCost)}
            </Grid>
        );
    }

    renderMeterTab() {
        const { meterBoxAssoID, meterBoxID, meterAmount, meterContext, meterResult, meterError, meterLoading } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="info">
                        Saisissez le BoxAssoID (ou le BoxID si non ambigu) d'un compteur deja enregistre.
                        L'abonnement, le total deja paye et la date du dernier paiement seront recuperes en
                        base et la simulation appliquera la meme logique que le paiement reel.
                    </Alert>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputText
                        type="text"
                        label="BoxAssoID"
                        value={meterBoxAssoID}
                        onChange={this.handleMeterChange}
                        name="meterBoxAssoID"
                        helperText="Prioritaire si fourni"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputText
                        type="text"
                        label="BoxID (compteur)"
                        value={meterBoxID}
                        onChange={this.handleMeterChange}
                        name="meterBoxID"
                        helperText="Resolu via association si BoxAssoID vide"
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputText
                        type="number"
                        label="Montant a simuler"
                        value={meterAmount}
                        onChange={this.handleMeterAmountChange}
                        name="meterAmount"
                    />
                </Grid>

                {meterLoading &&
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <CircularProgress size={24} />
                    </Grid>
                }

                {meterError &&
                    <Grid item xs={12}>
                        <Alert severity={meterResult && meterResult.MonthsUnpaid > 0 ? 'warning' : 'error'}>
                            {meterResult && meterResult.MonthsUnpaid > 0 && <strong>Ce paiement serait refuse en production : </strong>}
                            {meterError}
                        </Alert>
                    </Grid>
                }

                {meterContext && this.renderMeterContext(meterContext)}

                {meterResult && this.renderResultTable(meterResult, meterContext ? meterContext.fixcost : 0)}
            </Grid>
        );
    }

    renderMeterContext(ctx) {
        return (
            <Grid item xs={12}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                    <strong>Compteur enregistre - {ctx.subscriptionName}</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>BoxAssoID</TableCell>
                                <TableCell><code>{ctx.boxAssoID}</code></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>BoxID</TableCell>
                                <TableCell><code>{ctx.boxID}</code></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Type d'abonnement</TableCell>
                                <TableCell>{ctx.subscriptionType}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Raccordement</TableCell>
                                <TableCell>{formatNumber(ctx.deposit)} {ctx.currency}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>kWh offerts</TableCell>
                                <TableCell>{ctx.initialKWh} kWh</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Partie fixe mensuelle</TableCell>
                                <TableCell>{formatNumber(ctx.fixcost)} {ctx.currency}</TableCell>
                            </TableRow>
                            {(ctx.priceStepList || []).map((p, idx, arr) => {
                                const prevSeuil = idx === 0 ? 0 : (arr[idx - 1].nbKwh || 0);
                                const seuil = p.nbKwh || 0;
                                const label = seuil > 0 ? `${prevSeuil} -> ${seuil} kWh` : `${prevSeuil}+ kWh`;
                                return (
                                    <TableRow key={idx}>
                                        <TableCell>{label}</TableCell>
                                        <TableCell>{formatNumber(p.price)} / kWh</TableCell>
                                    </TableRow>
                                );
                            })}
                            <TableRow>
                                <TableCell>Total deja paye</TableCell>
                                <TableCell>{formatNumber(ctx.totalAlreadyPaid)} {ctx.currency}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Dernier paiement</TableCell>
                                <TableCell>{formatDate(ctx.lastPaymentDate)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Mensualites dues (calcul calendaire)</TableCell>
                                <TableCell>
                                    <strong>{ctx.monthDue}</strong>
                                    {ctx.isFirstPayment && <span style={{opacity: 0.7}}> (premier paiement - pas de partie fixe prelevee)</span>}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        );
    }

    renderResultTable(result, fixcost) {
        return (
            <Grid item xs={12}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                    <strong>Resultat</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>kWh credites</TableCell>
                                <TableCell><strong>{result.KWhCredited} kWh</strong>
                                    {result.KWhOfferts > 0 && result.KWhAchetes > 0 &&
                                        <span> ({result.KWhOfferts} offerts + {result.KWhAchetes} achetes)</span>
                                    }
                                    {result.KWhOfferts > 0 && result.KWhAchetes === 0 &&
                                        <span> (offerts)</span>
                                    }
                                    {result.KWhOfferts === 0 && result.KWhAchetes > 0 &&
                                        <span> (achetes)</span>
                                    }
                                </TableCell>
                            </TableRow>
                            {result.MonthsPaid > 0 &&
                            <TableRow>
                                <TableCell>Mensualites payees</TableCell>
                                <TableCell>{result.MonthsPaid} mois ({formatNumber(result.MonthsPaid * (parseFloat(fixcost) || 0))})</TableCell>
                            </TableRow>
                            }
                            {result.MonthsUnpaid > 0 &&
                            <TableRow>
                                <TableCell style={{color: '#d32f2f'}}>Mensualites impayees</TableCell>
                                <TableCell style={{color: '#d32f2f'}}><strong>{result.MonthsUnpaid} mois</strong> -- il manque {formatNumber(result.AmountMissing)}</TableCell>
                            </TableRow>
                            }
                            <TableRow>
                                <TableCell>Reste non utilise</TableCell>
                                <TableCell>{formatNumber(result.AmountLeftover)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        );
    }

    render() {
        const { tab } = this.state;

        return (
            <PopUp
                title="Simulation Paiement Prepaye"
                submitAction={this.submit}
                submitTitle="Simuler"
                close={this.props.close}
            >
                <Box mb={2}>
                    <Tabs
                        value={tab}
                        onChange={(_, v) => this.setState({ tab: v })}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab label="Parametres manuels" />
                        <Tab label="Compteur enregistre" />
                    </Tabs>
                </Box>

                {tab === 0 && this.renderManualTab()}
                {tab === 1 && this.renderMeterTab()}
            </PopUp>
        );
    }
}

export default NewSimulPrepaid;
